(() => {
  if (window.__tthWholesalePolicyInstalled) return;
  window.__tthWholesalePolicyInstalled = true;
  let opener = null;
  const dialog = () => document.querySelector('[data-wholesale-policy-dialog]');
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-wholesale-policy-open]');
    const node = dialog();
    if (open && node && typeof node.showModal === 'function') {
      event.preventDefault();
      opener = open;
      if (!node.open) node.showModal();
      node.querySelector('[data-wholesale-policy-close]')?.focus();
    }
    if (event.target.closest('[data-wholesale-policy-close]')) node?.close();
    if (node?.open && event.target === node) {
      const box = node.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) node.close();
    }
  });
  document.addEventListener('close', event => {
    if (event.target !== dialog()) return;
    if (opener?.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  }, true);
})();
